import { Fragment, FunctionComponent } from "react";
import TableIconCell from "./icon-cell";
import { faArrowDown, faArrowUp } from "components/icon-library";

interface TableMoveCellProps {
  item: any;
  isUpDisabled: boolean;
  isDownDisabled: boolean;
  onUp: (item: any) => Promise<void>;
  onDown: (item: any) => Promise<void>;
}

const TableMoveCell: FunctionComponent<TableMoveCellProps> = ({
  item,
  isUpDisabled,
  isDownDisabled,
  onUp,
  onDown,
}) => {
  const handleUp = async () => {
    onUp(item);
  };

  const handleDown = async () => {
    onDown(item);
  };

  return (
    <Fragment>
      <TableIconCell
        icon={faArrowUp}
        disabled={isUpDisabled}
        onClick={handleUp}
      />
      <TableIconCell
        icon={faArrowDown}
        disabled={isDownDisabled}
        onClick={handleDown}
      />
    </Fragment>
  );
};

export default TableMoveCell;
